import {
  fetchJMilestonesForJob,
  fetchJobsForProject,
  fetchProjectsForTimesheetLog,
  fetchTags,
} from "./form/api";

import { timesheetKeys } from "components/timesheet/queries";
import { useFetch } from "hooks/src/useFetch";

export default function useTimesheetData(date, formData) {
  const {
    data: projects,
    isLoading: isProjectsLoading,
    error: projectsError,
  } = useFetch({
    queryKey: timesheetKeys.logProjects(date),
    queryFn: () => fetchProjectsForTimesheetLog({ date }),
    enabled: !!date,
  });

  const {
    data: jobs,
    isLoading: isJobsLoading,
    error: jobsError,
  } = useFetch({
    queryKey: timesheetKeys.logProjectJobs(formData?.project, date),
    queryFn: () => fetchJobsForProject({ project: formData?.project, date }),
    enabled: !!formData?.project && !!date,
  });

  const {
    data: milestones,
    isLoading: isMilestonesLoading,
    error: milestonesError,
  } = useFetch({
    queryKey: timesheetKeys.logJobMilestones(
      formData?.project,
      formData?.job,
      date,
    ),
    queryFn: () => fetchJMilestonesForJob({ job: formData?.job }),
    enabled: !!formData?.job && !!date,
  });

  const {
    data: tag,
    isLoading: isTagLoading,
    error: tagError,
  } = useFetch({
    queryKey: timesheetKeys.logTags(),
    queryFn: () => fetchTags(),
    enabled: !!date,
  });

  return {
    projects,
    isProjectsLoading,
    projectsError,
    jobs,
    isJobsLoading,
    jobsError,
    milestones,
    isMilestonesLoading,
    milestonesError,
    tag,
    isTagLoading,
    tagError,
  };
}
